<template>
  <SkeletonWrapper
    :loading="loading"
    :width="params.width"
    :height="params.height"
  >
    <slot />
  </SkeletonWrapper>
</template>
<script setup lang="ts">
  import { computed } from 'vue';

  import { SkeletonWrapper } from '@/shared/ui/skeleton';
  import { useScreenSize } from '@experience/shared';

  withDefaults(defineProps<{ loading?: boolean }>(), { loading: false });

  const { isMobile, isTablet } = useScreenSize();

  const params = computed(() => {
    if (isMobile.value || isTablet.value) {
      return {
        width: 140,
        height: 14,
      };
    }

    return {
      width: 162,
      height: 16,
    };
  });
</script>
